var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 14,
    viewBox: "0 0 24 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 22.5,
    height: 12.5,
    rx: 1.25,
    stroke: "black",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.135 8.947H3.324C3.564 8.947 3.684 8.836 3.684 8.614V5.563C3.684 5.341 3.564 5.23 3.324 5.23H3.135V4.177H4.899L6.942 7.363V5.563C6.942 5.341 6.819 5.23 6.573 5.23H6.384V4.177H9.147V5.23H8.958C8.712 5.23 8.589 5.341 8.589 5.563V10H7.374L5.34 6.85V8.614C5.34 8.716 5.37 8.797 5.43 8.857C5.496 8.917 5.589 8.947 5.709 8.947H5.898V10H3.135V8.947ZM9.41918 8.956H9.60818C9.85418 8.956 9.97718 8.836 9.97718 8.596V5.563C9.97718 5.341 9.85418 5.23 9.60818 5.23H9.41918V4.177H14.0812V5.689H12.5692V5.572C12.5692 5.338 12.4462 5.221 12.2002 5.221H11.6422V6.571H12.6772V7.615H11.6422V8.956H12.2002C12.4462 8.956 12.5692 8.836 12.5692 8.596V8.488H14.0812V10H9.41918V8.956ZM14.92 5.68C14.878 5.494 14.812 5.374 14.722 5.32C14.638 5.26 14.491 5.23 14.281 5.23H14.218V4.177H16.108L16.702 7.048L17.314 5.158H18.466L19.078 7.048L19.672 4.177H21.562V5.23H21.499C21.289 5.23 21.139 5.26 21.049 5.32C20.965 5.374 20.902 5.494 20.86 5.68L19.906 10H18.583L17.89 8.038L17.197 10H15.874L14.92 5.68Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNew);
export default __webpack_public_path__ + "static/media/new.e226d0c1.svg";
export { ForwardRef as ReactComponent };